import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[appHover]',
  host: {
    '(mouseenter)': 'onMouseEnter()',
    '(mouseleave)': 'onMouseLeave()'
  }
})
export class HoverDirective {
  el: Element;

  constructor(el: ElementRef) {
    this.el = el.nativeElement;
  }

  onMouseEnter() {
    this.el.classList.add('hover');
  }

  onMouseLeave() {
    this.el.classList.remove('hover');
  }
}



// WEBPACK FOOTER //
// ./src/app/hover.directive.ts